<template>
  <div :class="type">
    <div class="thankYouText webinarsText">
      <h3>{{ t("Thank_you_label") }}</h3>
      <!--      <p>You have been successfully registered to the webinar.</p>-->
      <!--      <p>We will send you a reminder by phone and email 15 min before the webinar starts.</p>-->
      <p>{{ t("Webinar_register_success") }}</p>
    </div>
    <div class="thankYouText ebooksText">
      <h3>{{ t("Thank_you_label") }}</h3>
      <p>{{ t("ebook_sent") }}</p>
      <p>
        {{ t("didnt_receive_eBook") }}
        <span class="resend-btn">{{ t("resend_email") }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "message",
  props: ["type"],
  computed: {
    ...mapGetters(["t"])
  }
};
</script>

<style lang="scss" scoped>
.thankYouText {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f1f1f1;
  width: 100%;
  margin-bottom: 56px;
  text-align: center;
  h3 {
    font-size: 1.5rem;
    line-height: 1.875rem;
    font-weight: 500;
    color: #424242;
    margin-bottom: 0.5rem;
  }
  p {
    font-size: 1rem;
    line-height: 1.5rem;
    color: #333333;
  }
}

.webinarsText {
  display: none;
  p {
    max-width: 500px;
  }
}
.ebooksText {
  display: none;
}

.webinars {
  .webinarsText {
    display: flex;
  }
}

.ebook {
  .ebooksText {
    display: flex;
    p {
      &:first-of-type {
        margin-bottom: 24px;
      }
      .resend-btn {
        color: #1c79be;
        text-decoration: underline;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .thankYouText {
    background-color: transparent;
    padding: 0 1rem;
    &.webinarsText {
      margin-bottom: 48px;
      padding: 0 1.5rem;
    }
    &.ebooksText {
      margin-bottom: 32px;
      &:first-of-type {
        margin-bottom: 1.5rem;
      }
    }
    h3 {
      margin-bottom: 1rem;
    }
  }
}
</style>
